import * as types from '../actions/types';

const initialState = {
    searchannouncedata: [],
    success: false
}

export default function AnnouncementSearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_ANNOUNCMENT:
            return {
                searchannouncedata: action.payload,
                success: true
            }
        default:
            return state
    }
}
